import { TemplateTagResponseDTO } from '../email-template-service.types';
import { unlayerEmailTemplate } from './unlayerEmailTemplate.fixtures';

export const emailTemplates = [
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f1',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Welcome Offer Welcome Offer Welcome Offer Welcome Offer',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f2',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Discount Announcement',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f3',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'New Product Launch',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f4',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Holiday Sale',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f5',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Seasonal Promotion',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f6',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Exclusive Deal',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f7',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Special Offer',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f8',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Flash Sale',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f9',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Weekly Update',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51f0',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Monthly Newsletter',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51fA',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Black Friday Deals',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'MESSAGE',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51fB',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Cyber Monday Specials',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'MESSAGE',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51fC',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Year End Clearance',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'LOYALTY_OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51fD',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'New Year Offers',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'LOYALTY_OFFER',
    eventType: null,
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51fE',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Email Receipt',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'EVENT',
    eventType: 'GIFT_CARD_EMAIL_RECEIPT',
    reusable: true,
  },
  {
    templateId: '003793f3-e1a3-41e4-aa6c-8174134c51fF',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    name: 'Account Verification',
    jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
    htmlTemplate: unlayerEmailTemplate.html,
    fromAddress: null,
    bcc: null,
    subject: 'test subject',
    emailTemplateType: 'EVENT',
    eventType: 'VERIFY_EMAIL',
    reusable: true,
  },
];

export const newEmailTemplate = {
  templateId: 'newtemplate',
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
  name: 'New Template',
  jsonTemplate: JSON.stringify(unlayerEmailTemplate.design),
  htmlTemplate: unlayerEmailTemplate.html,
  fromAddress: null,
  bcc: null,
  subject: 'test subject',
  emailTemplateType: 'OFFER',
  eventType: null,
  reusable: true,
};

export const mergeTags: TemplateTagResponseDTO[] = [
  {
    type: 'OFFER',
    tag: JSON.stringify({
      name: 'Title',
      value: '[#title#]',
      sample: 'The Offer Title',
    }),
  },
  {
    type: 'OFFER',
    tag: JSON.stringify({
      name: 'Short Description',
      value: '[#short_description#]',
      sample: 'This will be replaced with the short description of the offer',
    }),
  },
  {
    type: 'EVENT',
    eventType: 'VERIFY_EMAIL',
    tag: JSON.stringify({
      name: 'Verification Url',
      value: '[#incentivio_verification_url#]',
      sample: 'The Offer Title',
    }),
    specialLink: true,
    required: true,
  },
  {
    type: 'EVENT',
    eventType: 'GIFT_CARD_EMAIL_RECEIPT',
    tag: JSON.stringify({
      name: 'Sender Name',
      value: '[#senderName#]',
      sample: 'John Smith',
    }),
  },
];

export const testMergeTags: TemplateTagResponseDTO[] = [
  {
    type: 'OFFER',
    tag: JSON.stringify({
      name: 'Title',
      value: '[#title#]',
      sample: 'The Offer Title',
    }),
  },
  {
    type: 'OFFER',
    tag: JSON.stringify({
      name: 'Short Description',
      value: '[#short_description#]',
      sample: 'This will be replaced with the short description of the offer',
    }),
    required: true,
  },
  {
    type: 'OFFER',
    tag: JSON.stringify({
      name: 'test',
      value: '[#test#]',
      sample: 'This will be replaced with the short description of the offer',
    }),
    specialLink: true,
  },
  {
    type: 'OFFER',
    tag: JSON.stringify({
      name: 'Unsubscribe Url',
      value: '[#unsubscribe_url#]',
      sample: 'Unsubscribe',
    }),
    specialLink: true,
    required: true,
  },
  {
    type: 'EVENT',
    eventType: 'VERIFY_EMAIL',
    tag: JSON.stringify({
      name: 'Verification Url',
      value: '[#incentivio_verification_url#]',
      sample: 'The Offer Title',
    }),
    specialLink: true,
    required: true,
  },
  {
    type: 'EVENT',
    eventType: 'GIFT_CARD_EMAIL_RECEIPT',
    tag: JSON.stringify({
      name: 'Sender Name',
      value: '[#senderName#]',
      sample: 'John Smith',
    }),
  },
  {
    type: 'EVENT',
    eventType: 'GIFT_CARD_EMAIL_RECEIPT',
    tag: JSON.stringify({
      name: 'test',
      value: '[#test#]',
      sample: 'John Smith',
    }),
    required: true,
  },
  {
    type: 'EVENT',
    eventType: 'GIFT_CARD_EMAIL_RECEIPT',
    tag: JSON.stringify({
      name: 'test2',
      value: '[#test2#]',
      sample: 'John Smith',
    }),
    specialLink: true,
  },
];
